<template>
  <BasePageContainer>
    <SettingHeader>ノートテンプレートの管理</SettingHeader>
    <div class="pt-10 pb-4">
      <!-- lost など不要なグループを選ばせないため、選択肢は自分に閲覧権限のあるグループだけ -->
      <NoteTemplateForm
        :department-options="accessibleDepartments"
        :response-errors="responseErrors"
        @submit="submit" />
    </div>
  </BasePageContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingHeader from '@/components/parts/SettingHeader.vue'
import NoteTemplateForm from '@/components/view/note_templates/NoteTemplateForm.vue'

export default {
  name: 'NoteTemplateAdd',
  components: {
    SettingHeader,
    NoteTemplateForm
  },
  data() {
    return {
      responseErrors: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['accessibleDepartments'])
  },
  methods: {
    async submit(body) {
      this.$store.commit('startLoading')
      await this.$axios.post('/note_templates/', body).then(res => {
        this.$store.commit('notify/set', { message: `${res.data.name}を作成しました。` })
        this.$router.push('/admin/note_templates/')
      }).catch(e => {
        console.error(e)
        this.responseErrors = e.response?.data || {}
        this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
      })
      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style scoped>
</style>
